import React from "react";
import { ClassNameProps, If, Row, StyleProps } from "@hex-insights/core";
import { truncateDisplayItems } from "../../../../Utilities";
import { IconPerson, PersonAdditionalCountIcon, PersonIcon } from "../Icon";
import styles from "./styles.module.css";

export type PeopleCondensedListProps = {
	people: IconPerson[];
	maxDisplayed?: number;
	iconSize: number;
} & Partial<ClassNameProps & StyleProps>;

export function PeopleCondensedList({
	people,
	maxDisplayed = 6,
	iconSize,
	className,
	style,
}: PeopleCondensedListProps) {
	const { displayedItems, anyHidden, numHidden } = truncateDisplayItems(people, maxDisplayed);

	return (
		<Row className={className} style={{ ...style, "--person-icon---size": `${iconSize}px` } as React.CSSProperties}>
			{displayedItems.map((person) => (
				<PersonIcon
					key={person.id}
					person={person}
					size={iconSize}
					className={styles["people-condensed-list__person-icon"]}
				/>
			))}

			<If condition={anyHidden}>
				<PersonAdditionalCountIcon
					count={numHidden}
					size={iconSize}
					className={styles["people-condensed-list__person-icon"]}
				/>
			</If>
		</Row>
	);
}
